import Vue from 'vue'
import Router from 'vue-router'
Vue.use( Router )

const routes = [
    {
      path: '*',
      redirect: '/home',
      name: 'home',
      component: () => import('@/view/official-website/home.vue') // ireader官网
    },
    {
      path: '/',
      redirect: '/home',
      name: 'home',
      component: () => import('@/view/official-website/home.vue') // ireader官网
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/view/official-website/home.vue')
    },
    {
      path: '/writer-benefit',
      name: 'writer_benefit',
      meta: {
        title: "iReader Writer's benefit",
        description: "Find a brand new Writer's Benefits here for both Exclusive and Non-Exclusive stories",
        image: 'https://www.ireader.mobi/web/static/img/writer-benefit-new.jpg'
      },
      component: () => import('@/view/ugc-activity/writer-benefit/index.vue')
    },
    {
      path: '/writing-contest-phase4',
      name: 'writing_contest_phase4',
      meta: {
        title: 'Into The Wolfpack',
        description: 'Set your imagination free and embark on a captivating journey of werewolf story.',
        image: 'https://www.ireader.mobi/web/static/img/writing-contest-phase4.jpg'
      },
      component: () => import('@/view/ugc-activity/writing-contest-phase4/index.vue')
    },
    {
      path: '/writing-contest-phase4-new',
      name: 'writing_contest',
      meta: {
        title: 'In Love With Enemy',
        description: 'Set your imagination free and embark on a captivating journey of werewolf story.',
        image: 'https://www.ireader.mobi/web/static/img/writing-contest-new.jpg'
      },
      component: () => import('@/view/ugc-activity/writing-contest-phase4-new/index.vue')
    },
    {
      path: '/writing-contest-phase4-prize',
      name: 'writing_prize',
      meta: {
        title: 'Love&Hate With Alpha',
        description: 'Winners of Love&Hate With Alpha',
        image: 'https://www.ireader.mobi/web/static/img/writing-contest-phase4-prize.jpg'
      },
      component: () => import('@/view/ugc-activity/writing-contest-phase4-prize/index.vue')
    },
    {
      path: '/writing-contest-into-the-wolf-pack',
      name: 'writing_contest_into_the_wolf_pack',
      meta: {
        title: 'Winners of Into the Wolf Pack Writing Contest',
        description: 'A four-month exciting writing contest has witnessed excellent results from brilliant authors.',
        image: 'https://www.ireader.mobi/web/static/img/writing-contest-into-the-wolf-pack.jpg'
      },
      component: () => import('@/view/ugc-activity/writing-contest-into-the-wolf-pack/index.vue')
    },
    {
      path: '/rejected-by-my-lover',
      name: 'rejected_by_my_lover',
      meta: {
        title: "Join iReader's New Writing Contest!",
        description: 'Please pay attention to our latest call for werewolf/billionaire romance stories theme in Rejected by My Lover.',
        image: 'https://www.ireader.mobi/web/static/img/rejected-by-my-lover.jpg'
      },
      component: () => import('@/view/ugc-activity/rejected-by-my-lover/index.vue')
    },
    {
      path: '/romance-of-reverse-harem',
      name: 'romance_of_reverse_harem',
      meta: {
        title: "Join iReader's New Writing Contest!",
        description: 'Please pay attention to our latest call for werewolf/billionaire romance stories theme in Romance of Reverse Harem.',
        image: 'https://www.ireader.mobi/web/static/img/romance-of-reverse-harem.jpg'
      },
      component: () => import('@/view/ugc-activity/romance-of-reverse-harem/index.vue')
    },
    {
      path: '/savior-protector-sweet-mate',
      name: 'savior_protector_sweet_mate',
      meta: {
        title: "Join iReader's New Writing Contest!",
        description: 'Please pay attention to our latest call for romance stories themed in My Savior, My Protector, My Sweet Mate.',
        image: 'https://www.ireader.mobi/web/static/img/savior-protector-sweet-mate.jpg'
      },
      component: () => import('@/view/ugc-activity/savior-protector-sweet-mate/index.vue')
    },
    {
      path: '/in-love-with-my',
      name: 'in_love_with_my',
      meta: {
        title: "Join iReader's New Writing Contest!",
        description: 'Please pay attention to our latest call for In Love with My Step-xxx Writing Contest. ',
        image: 'https://www.ireader.mobi/web/static/img/in-love-with-my.jpg'
      },
      component: () => import('@/view/ugc-activity/in-love-with-my/index.vue')
    },
    {
      path: '/writing-in-love-with-my',
      name: 'writing_in_love_with_my',
      meta: {
        title: "Join iReader's New Writing Contest!",
        description: 'Please pay attention to our latest call for In Love with My Step-xxx Writing Contest. ',
        image: 'https://pic.ireadercdn.com/resource1/D1/45/3D511BAE5C31EDA07C635DFD628F5A2F.png?v=7e2d6fa0'
      },
      component: () => import('@/view/ugc-activity/writing-in-love-with-my/index.vue')
    },
    {
      path: '/completed-short-stories',
      name: 'completed_short_stories',
      meta: {
        title: "Join iReader's New Writing Contest!",
        description: 'Please pay attention to our latest call for Completed Short Stories. ',
        image: 'https://www.ireader.mobi/web/static/img/completed-short-stories.jpg'
      },
      component: () => import('@/view/ugc-activity/completed-short-stories/index.vue')
    },
    {
      path: '/watch-me-win-ex',
      name: 'watch-me-win-ex',
      meta: {
        title: "Join iReader's New Writing Contest!",
        description: 'Please pay attention to our latest call for Watch Me Win, Ex! Writing Contest. ',
        image: 'https://www.ireader.mobi/web/static/img/watch-me-win-ex.jpg'
      },
      component: () => import('@/view/ugc-activity/watch-me-win-ex/index.vue')
    },
    {
      path: '/he-wants-me',
      name: 'he-wants-me',
      meta: {
        title: "He Wants Me, and He Wants More!",
        description: "Please pay attention to our latest call for He Wants Me, and He Wants More Writing Contest. ",
        image: 'https://www.ireader.mobi/web/static/img/he-wants-me.jpg'
      },
      component: () => import('@/view/ugc-activity/he-wants-me/index.vue')
    },
    {
      path: '/papers',
      name: 'papers',
      component: () => import('@/view/papers/papers.vue')
    },
    {
      path: '/papers_details',
      name: 'papersDetails',
      component: () => import('@/view/papers/details.vue')
    },
    {
      path: '/privacyEN',
      name: 'privacyEN',
      component: () => import('@/view/privacy/en/privacyEN.vue')
    },
    {
      path: '/termsEN',
      name: 'termsEN',
      component: () => import('@/view/privacy/en/termsEN.vue')
    },
    {
      path: '/privacyBibleEN',
      name: 'privacyBibleEN',
      component: () => import('@/view/privacy/en/privacyBibleEN.vue')
    },
    {
      path: '/termsBibleEN',
      name: 'termsBibleEN',
      component: () => import('@/view/privacy/en/termsBibleEN.vue')
    },
    {
      path: '/privacyTW',
      name: 'privacyTW',
      component: () => import('@/view/privacy/tw/privacyTW.vue')
    },
    {
      path: '/termsTW',
      name: 'termsTW',
      component: () => import('@/view/privacy/tw/termsTW.vue')
    },
    {
      path: '/termsES',
      name: 'termsES',
      component: () => import('@/view/privacy/es/termsES.vue')
    },
    {
      path: '/privacyES',
      name: 'privacyES',
      component: () => import('@/view/privacy/es/privacyES.vue')
    },
    {
      path: '/termsPOR',
      name: 'termsPOR',
      component: () => import('@/view/privacy/por/termsPOR.vue')
    },
    {
      path: '/privacyPOR',
      name: 'privacyPOR',
      component: () => import('@/view/privacy/por/privacyPOR.vue')
    },
    {
      path: '/termsTH',
      name: 'termsTH',
      component: () => import('@/view/privacy/th/termsTH.vue')
    },
    {
      path: '/privacyTH',
      name: 'privacyTH',
      component: () => import('@/view/privacy/th/privacyTH.vue')
    },
    {
      path: '/termsKO',
      name: 'termsKO',
      component: () => import('@/view/privacy/ko/termsKO.vue')
    },
    {
      path: '/privacyKO',
      name: 'privacyKO',
      component: () => import('@/view/privacy/ko/privacyKO.vue')
    },
]


const router = new Router({
  mode: 'history',
  base: '/web',
  routes: routes
} )

router.beforeEach( ( to, from, next ) => {
  if (to.meta.title) {
    document.querySelector('meta[property="og:title"]').setAttribute('content', to.meta.title)
  }
  if (to.meta.description) {
    document.querySelector('meta[property="og:description"]').setAttribute('content', to.meta.description)
  }
  if (to.meta.image) {
    document.querySelector('meta[property="og:image"]').setAttribute('content', to.meta.image)
  }
  next()
 }
)
export default router



// WEBPACK FOOTER //
// ./src/router/index.js